import axios from 'axios';
import store from '../../redux/store';
import systemSlice from '../../redux/systemSlice';
import { v4 as uuid } from 'uuid';
const checkOTP = async (props: { responseData: { result: any, error: boolean, errorType: string }, createActionProps: any }) => {
    const { responseData, createActionProps } = props
    const errorMessage: any = responseData?.result?.data?.resultMessage
    if (responseData.error && errorMessage === "OTP_REQUIRED") {
        const transactionid = responseData?.result?.data?.resultData?.id
        const resolveId = uuid()
        const newResponseData: { result: any, error: boolean, errorType: string } = await new Promise(resolve => {
            //@ts-ignore
            globalThis[resolveId] = resolve
            localStorage.setItem("transactionid", transactionid)
            store.dispatch(systemSlice.actions.setOTPProps({ createActionProps, resolveId }))

        })
        //@ts-ignore
        delete globalThis[resolveId]

        return newResponseData

    }

    return responseData;

};

export default checkOTP;


